module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_1@3x.ab0db258.png";